import { Bike, Smartphone, UtensilsCrossed } from 'lucide-react';

const STEPS = [
  {
    icon: UtensilsCrossed,
    step: 'Step 1',
    title: 'Chagua chakula',
    titleEn: 'Pick your meal',
    description:
      'Breakfast, lunch or dinner — the menu highlights what the jiko is cooking right now. Add your favourites to the basket.',
  },
  {
    icon: Smartphone,
    step: 'Step 2',
    title: 'Lipa papo hapo',
    titleEn: 'Pay instantly',
    description:
      'Checkout with M-Pesa STK push or approve in your Tando app. Prefer cash? Pay the rider at your door.',
  },
  {
    icon: Bike,
    step: 'Step 3',
    title: 'Tunafika haraka',
    titleEn: 'We deliver hot',
    description:
      'Your food leaves the jiko sealed and steaming. Average delivery across Nairobi is just 30–45 minutes.',
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="scroll-mt-20 border-y border-border bg-card py-16 sm:py-20">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary">How it works</p>
          <h2 className="mt-3 font-display text-4xl font-black tracking-tight sm:text-5xl">
            From our jiko to your <span className="italic text-primary">mlango</span>
          </h2>
          <p className="mt-3 text-lg text-muted-foreground">
            Three simple steps and dinner is sorted — hakuna stress.
          </p>
        </div>

        <ol className="mt-12 grid gap-6 md:grid-cols-3">
          {STEPS.map(({ icon: Icon, step, title, titleEn, description }, i) => (
            <li
              key={title}
              className="relative rounded-2xl border border-border bg-background p-6 shadow-sm transition-shadow hover:shadow-lg"
            >
              <div className="flex items-center justify-between">
                <span className="flex size-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                  <Icon className="size-6" />
                </span>
                <span className="font-display text-5xl font-black text-primary/10">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-muted-foreground">{step}</p>
              <h3 className="mt-1.5 font-display text-xl font-bold">
                {title} <span className="text-muted-foreground">· {titleEn}</span>
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
